export const FACTS = [
  'shared:Conference.waiting_room_facts.fact_1',
  'shared:Conference.waiting_room_facts.fact_2',
  'shared:Conference.waiting_room_facts.fact_3',
  'shared:Conference.waiting_room_facts.fact_4',
  'shared:Conference.waiting_room_facts.fact_5',
  'shared:Conference.waiting_room_facts.fact_6',
  'shared:Conference.waiting_room_facts.fact_7',
  'shared:Conference.waiting_room_facts.fact_8',
  'shared:Conference.waiting_room_facts.fact_9',
  'shared:Conference.waiting_room_facts.fact_10',
  'shared:Conference.waiting_room_facts.fact_11',
  'shared:Conference.waiting_room_facts.fact_12',
  'shared:Conference.waiting_room_facts.fact_13',
  'shared:Conference.waiting_room_facts.fact_14',
  'shared:Conference.waiting_room_facts.fact_15',
  'shared:Conference.waiting_room_facts.fact_16',
  'shared:Conference.waiting_room_facts.fact_17',
] as const;

export const FACT_CHANGE_INTERVAL_IN_SECONDS = 30;
